import {Button, Modal} from 'letrus-ui';
import styles from './AiNoticeModal.module.scss';

export interface AiNoticeModalProps {
  id: string;
  onClose(): void;
}

function AiNoticeModal({id, onClose}: AiNoticeModalProps): JSX.Element {
  return (
    <Modal id={id} className={styles.modal}>
      <div className={styles.content} data-testid="aiNoticeModal">
        <h2>Novidade: Como a Letrus cuida da autoria dos textos</h2>

        <p>
          A Letrus conta com um recurso que ajuda a identificar características
          de escrita que podem estar associadas ao uso de ferramentas de IA. Ele
          funciona para todas as redações enviadas na plataforma, e não é uma
          acusação.
        </p>
        <p>
          O resultado é apenas um apoio para o(a) professor(a), que conhece a
          sua escrita e é quem avalia o seu texto. Esse recurso não define a sua
          nota.
        </p>

        <div className={styles.actions}>
          <Button variant="primary" type="button" onClick={onClose}>
            Entendi
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default AiNoticeModal;
